import { render, staticRenderFns } from "./SingleOrder.vue?vue&type=template&id=5d4524ac&scoped=true"
import script from "./SingleOrder.vue?vue&type=script&lang=js"
export * from "./SingleOrder.vue?vue&type=script&lang=js"
import style0 from "./SingleOrder.vue?vue&type=style&index=0&id=5d4524ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4524ac",
  null
  
)

export default component.exports